import {get} from '@/lib/request'

function tagIndexPath() {
  return `/wp/v2/tags`
}

export function listTags() {
  return get(tagIndexPath())
}
